import { render, staticRenderFns } from "./MandateEditForm.vue?vue&type=template&id=752eec6f&"
import script from "./MandateEditForm.vue?vue&type=script&lang=js&"
export * from "./MandateEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports